module.exports = __webpack_public_path__ + "static/media/Bryan Soukup Headshot.fa809471.jpeg";